var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { OptionCardOldCore, } from '@core-front/option-card-old';
import Badge from '@telia-front/badge';
import Icon from '@telia-front/icon';
import Tag from '@telia-front/tag';
export default class OptionCardOld extends React.Component {
    BEM() {
        const classArray = [this.props.className];
        if (this.props.padding) {
            classArray.push('option-card-old--' + this.props.padding);
        }
        return classArray.join(' ');
    }
    getBadgeTopProps(badgeTop) {
        if (typeof badgeTop === 'boolean' || !badgeTop) {
            return !!badgeTop;
        }
        if (badgeTop.text) {
            return { text: badgeTop.text };
        }
        else if (badgeTop.icon) {
            return { icon: badgeTop.icon };
        }
        return false;
    }
    getBadgePurpose(badgeTop) {
        if (typeof badgeTop === 'boolean' || !badgeTop) {
            return null;
        }
        return { purpose: badgeTop.purpose };
    }
    getTag() {
        if (this.props.tagTop) {
            return React.createElement(Tag, Object.assign({ className: "option-card-old__tag--top" }, this.props.tagTop));
        }
    }
    getBadgeProps(badgeTop) {
        if (typeof badgeTop === 'boolean' || !badgeTop) {
            return undefined;
        }
        return badgeTop;
    }
    render() {
        const _a = this.props, { padding, badgeTop } = _a, rest = __rest(_a, ["padding", "badgeTop"]);
        return (React.createElement(OptionCardOldCore, Object.assign({}, rest, { badgeTop: this.getBadgeTopProps(badgeTop), className: this.BEM(), tagTopContent: this.getTag(), components: {
                Badge: (props) => React.createElement(Badge, Object.assign({}, props)),
                BadgeTop: (props) => React.createElement(Badge, Object.assign({}, props, this.getBadgeProps(badgeTop), this.getBadgePurpose(badgeTop))),
                Icon,
            } })));
    }
}
